import { graphql } from '../gql'

/**
 * GraphQL operations for the time clock.
 */

/** Fragment: Core time clock data. */
export const TimeClockFragment = graphql(`
	fragment TimeClockData on TimeClock {
		id
		startTime
		endTime
		task {
			id
			name
			payable
		}
		shift {
			id
			startTime
			endTime
		}
	}
`)

/** Query: Get current time clock status. */
export const GetTimeClockQuery = graphql(`
	query GetTimeClock {
		me {
			id
			... on Operator {
				timeClock {
					...TimeClockData
				}
			}
		}
	}
`)

/** Query: Get available time clock tasks. */
export const GetTimeClockTasksQuery = graphql(`
	query GetTimeClockTasks(
		$where: QueryTimeClockTasksWhereInput
		$noteRequired: TimeClockIsNotRequiredWhereInput
		$geoRequired: TimeClockIsGeoRequiredWhereInput
	) {
		timeClockTasks(where: $where) {
			id
			name
			isNoteRequired(where: $noteRequired)
			noteRequired
			isGeoRequired(where: $geoRequired)
			geoRequired
			payable
			sort
		}
	}
`)

/** Mutation: Clock in. */
export const ClockInMutation = graphql(`
	mutation ClockIn($data: TimesheetClockInInput!) {
		timeClock {
			clockIn(data: $data) {
				timeClock {
					...TimeClockData
				}
			}
		}
	}
`)

/** Mutation: Clock out. */
export const ClockOutMutation = graphql(`
	mutation ClockOut($data: TimesheetClockOutInput!) {
		timeClock {
			clockOut(data: $data) {
				timeClock {
					...TimeClockData
				}
			}
		}
	}
`)

/** Mutation: Change task. */
export const ChangeTaskMutation = graphql(`
	mutation ChangeTask($data: TimesheetChangeTaskInput!) {
		timeClock {
			changeTask(data: $data) {
				timeClock {
					...TimeClockData
				}
			}
		}
	}
`)

/** Query: Get time sheet for history. */
export const GetTimeSheetQuery = graphql(`
	query GetTimeSheet($where: PersonTimeSheetWhereInput) {
		me {
			id
			... on Operator {
				# includeVoided keeps a day on the history even when its every
				# entry is voided — the list below strikes those through.
				timeSheet(where: $where, includeVoided: true) {
					id
					startTime
					endTime
					# History shows voided entries struck through and subtracts them
					# from the totals itself, so both lists have to carry them.
					shifts(includeVoided: true) {
						id
						startTime
						endTime
						timeClocks(includeVoided: true) {
							id
							startTime
							endTime
							voided
							voidReason
							voidReasonDetails {
								name
							}
							task {
								id
								name
								sort
								color
							}
						}
					}
				}
			}
		}
	}
`)
